import i18next from 'i18next';

i18next.addResources('en', 'StatusBadge', {
  inProgress: 'In progress',
  notStarted: 'Not started',
  completed: 'Completed'
});
